import styled from '@emotion/styled';
import { FileCopy } from '@mui/icons-material';
import { TableCell, TableRow } from '@mui/material';
import Theme from 'App.theme';
import * as FileUploadStyles from 'components/FileUpload/FileUpload.styles';

export const DataUploadPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 600px;
  width: 100%;
  margin: auto;
  gap: 1rem;
`;

export const DropzoneContainer = styled.div`
  height: 15rem;
`;

export const FileUploadContainer = styled(FileUploadStyles.FileUploadContainer)`
  height: 100%;
  width: 100%;
  border-color: ${Theme.greys.GREY2};
`;

export const FileUploadRoot = styled(FileUploadStyles.FileUploadRoot)``;

export const FileUploadContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const FileUploadIcon = styled(FileCopy)`
  font-size: 80px;
  margin: 30px;
`;

export const FileUploadInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
export const FileUploadList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  border-radius: 1rem;
  border: 2px solid rgba(0, 0, 0, 0.4);
  padding: 1rem;
  overflow: auto;
  height: 20rem;
`;

export const Cell = styled(TableCell)`
  max-width: 80px;
`;

export const TableCellDiv = styled.div`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileUploadItem = styled(TableRow)``;

export const FileUploadActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
